<template>
    <div>
        <v-row>
           
            <v-col cols="12" md="3">
                <v-card tile>
                    <v-list-item three-line>
                        <v-list-item-content>
                            <div class="custom-header my-4">
                                {{ $t('Sum') }} {{ $t('Tasks') }}
                            </div>
                            <v-list-item-title class="text-h5 mb-1" />
                        </v-list-item-content>
                        <v-list-item-avatar tile size="80" color="#53646d">
                            <h1 class="white--text">{{ totalTasks }}</h1>
                        </v-list-item-avatar>
                    </v-list-item>
                </v-card>
            </v-col>
            <v-col cols="12" md="3">
                <v-card tile>
                    <v-list-item three-line>
                        <v-list-item-content>
                            <div class="custom-header my-4">
                                {{ $t('Count') }} {{ $t('Tasks') }}
                            </div>
                            <v-list-item-title class="text-h5 mb-1" />
                        </v-list-item-content>
                        <v-list-item-avatar tile size="80" color="grey lighten-1">
                            <h1 class="white--text">{{ pendingTasks }}</h1>
                        </v-list-item-avatar>
                    </v-list-item>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3">
                <progress-circular :value="pendingTasksPercentage" :size="150" :width="15" color="primary" :title="$t('UncompletedTaskCount')" />
            </v-col>
            <v-col cols="3">
                <progress-circular :value="completedTasksPercentage" :size="150" :width="15" color="teal" :title="$t('CompletedTaskCount')" />
            </v-col>

            <v-col cols="3">
                <progress-circular :value="delayedTasksPercentage" :size="150" :width="15" color="primary" :title="$t('DelayedTasks')" />
            </v-col>
            <v-col cols="3">
                <bar :height="200" v-if="barSeries[0].data.length > 0" :series="barSeries" :categories="labels" :title="$t('Tasks')" />
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import ProgressCircular from '@/components/app/charts/ProgressCircular.vue'
    import Bar from '@/components/app/charts/Bar.vue'


    export default {

        components: {
            ProgressCircular,  Bar
        },

        data() {
            return {
                commentCount: 0,
                pendingTasks: 0,
                completedTasks: 0,
                delayedTasks: 0,
                labels: [this.$t('DelayedTasks'), this.$t('CompletedTaskCount'), this.$t('UncompletedTaskCount')],
                barSeries: [
                    {
                        data: []
                    }
                ],
            }
        },

        computed: {
            pendingTasksPercentage() {
                return Math.round(this.pendingTasks * 100 / (this.pendingTasks + this.completedTasks))
            },

            completedTasksPercentage() {
                return Math.round(this.completedTasks * 100 / (this.pendingTasks + this.completedTasks))
            },

            totalTasks() {
                return this.pendingTasks + this.completedTasks
            },
            delayedTasksPercentage() {
                return Math.round(this.delayedTasks * 100 / this.pendingTasks)
            },
        },

        created() {
            this.listDashboardItems()
        },

        methods: {

            listDashboardItems() {
                let promises = [
                    //DashboardService.getPendingTasksCount(1),
                ]

                Promise.all(promises)
                    .then(
                        ([
                          //  commentCount
                        ]) => {
                            //this.commentCount = commentCount.data
                        },
                    ).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {

                    })
            },

        }
    }
</script>